// Action Types
export const CREATE_DEAL_REQUEST = "CREATE_DEAL_REQUEST";
export const CREATE_DEAL_SUCCESS = "CREATE_DEAL_SUCCESS";
export const CREATE_DEAL_FAILURE = "CREATE_DEAL_FAILURE";

// Action Creators
export const createDealRequest = ({opportunityIds, userId,clientName,accountName}) => {
  return (dispatch) => {
    dispatch({
      type: CREATE_DEAL_REQUEST,
      payload: {opportunityIds, userId,clientName,accountName},
    });
  };
};

export const createDealSuccess = (data) => ({
  type: CREATE_DEAL_SUCCESS,
  payload: data,
});

export const createDealFailure = (error) => ({
  type: CREATE_DEAL_FAILURE,
  payload: error,
});